import { IconProps } from "../../utils/global-types/global-types";

const DownloadTwoIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M15.75 14.25H2.25a.75.75 0 1 0 0 1.5h13.5a.75.75 0 1 0 0-1.5M9 1.5a.75.75 0 0 0-.75.75v7.943L5.782 7.718a.753.753 0 0 0-1.065 1.065l3.75 3.75a.75.75 0 0 0 1.065 0l3.75-3.75a.753.753 0 0 0-1.065-1.065L9.75 10.193V2.25A.75.75 0 0 0 9 1.5"
      ></path>
    </svg>
  );
};

export default DownloadTwoIcon;
